var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedinIconFooter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666748 17.5C0.666748 7.83502 8.50176 0 18.1667 0C27.8317 0 35.6667 7.83502 35.6667 17.5C35.6667 27.165 27.8317 35 18.1667 35C8.50176 35 0.666748 27.165 0.666748 17.5Z",
    fill: "#1E9FD4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2951 10.8082C13.2694 9.63988 12.4339 8.75 11.0772 8.75C9.72046 8.75 8.8335 9.63988 8.8335 10.8082C8.8335 11.9524 9.69425 12.8679 11.0257 12.8679H11.051C12.4339 12.8679 13.2951 11.9524 13.2951 10.8082Z",
    fill: "#1E9FD4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0339 14.4943H9.06801V26.4102H13.0339V14.4943Z",
    fill: "#1E9FD4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7702 14.2145C25.3799 14.2145 27.3364 15.9179 27.3364 19.5779L27.3362 26.4101H23.3705V20.0351C23.3705 18.4339 22.7966 17.3412 21.361 17.3412C20.2653 17.3412 19.6127 18.0778 19.3261 18.7893C19.2212 19.0443 19.1955 19.3995 19.1955 19.7556V26.4104H15.2291C15.2291 26.4104 15.2814 15.6127 15.2291 14.4946H19.1955V16.1824C19.7218 15.371 20.6646 14.2145 22.7702 14.2145Z",
    fill: "#1E9FD4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIconFooter);
export default __webpack_public_path__ + "static/media/linkedinIconFooter.1cdae34f922f18febefa03e4f043886e.svg";
export { ForwardRef as ReactComponent };